import {PageContainer} from '@/components/PageContainer/RevisedPageContainer';
import {Outlet} from 'react-router-dom';
import {Navbar} from '../components/Navbar/Navbar';

export default function TrainerNavbarLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-1 pb-[70px]">
        <PageContainer>
          <Outlet />
        </PageContainer>
      </div>
      <Navbar />
    </div>
  );
}
